<script setup>
import { useMeta } from 'vue-meta'
import AdminSidebar from '@/partials/sidebars/AdminSidebar.vue'
import { SidebarLayout } from '@/components/ui/layouts'

useMeta({
    title: 'Admin',
})
</script>

<template>
    <SidebarLayout>
        <template #sidebar>
            <AdminSidebar />
        </template>
        <template #main>
            <router-view />
        </template>
    </SidebarLayout>
</template>
